import React from 'react';
import { DashboardStats } from '../../types/api';
import { formatTokenAmount, formatNumber, formatPercentage, formatDuration } from '../../lib/utils';

interface StatsCardsProps {
  stats?: DashboardStats;
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  if (!stats) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-white rounded-lg shadow p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: 'Total Transactions',
      value: formatNumber(stats.totalTransactions),
      icon: '💳',
      color: 'blue'
    },
    {
      title: 'Success Rate',
      value: formatPercentage(stats.successRate),
      icon: '✅',
      color: 'green'
    },
    {
      title: 'Total Volume',
      value: `${formatTokenAmount(stats.totalVolume, 2)} PFVS`,
      icon: '💰',
      color: 'purple'
    },
    {
      title: 'Avg Processing Time',
      value: formatDuration(stats.averageProcessingTime * 1000),
      icon: '⏱️',
      color: 'orange'
    }
  ];

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return 'text-blue-600 bg-blue-100';
      case 'green':
        return 'text-green-600 bg-green-100';
      case 'purple':
        return 'text-purple-600 bg-purple-100';
      case 'orange':
        return 'text-orange-600 bg-orange-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((card, index) => (
        <div key={index} className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <div className={`flex-shrink-0 rounded-md p-3 ${getColorClasses(card.color)}`}>
              <span className="text-2xl">{card.icon}</span>
            </div>
            <div className="ml-4">
              <h3 className="text-sm font-medium text-gray-900">{card.title}</h3>
              <p className="text-2xl font-semibold text-gray-700">{card.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards; 